// 共用圖示按鈕：線描 icon（沿用 Unity SlotFramework/Art/UI/BottomBar 的 btn_* 圖）+ hover/按下動效 + 點擊回呼。
// 底部操作列的 選單／資訊／錢包／押注／Turbo／自動 皆複用此元件；文字（餘額、押注額）由外部另做，
// 讓 IconButton 專注於「一顆可點的圖示」這個單一職責。
// 開關態（Turbo／自動）照 Unity 以「換圖」表示（BottomBarView.cs 的 turboOffSprite/turboQuickSprite、
// btn_auto/btn_auto_on），不用著色，故本元件提供 setTexture 而非 tint 切換。

import { Container, Rectangle, Sprite, type Texture } from 'pixi.js'

export class IconButton extends Container {
  private readonly icon: Sprite
  private baseScale = 1
  private enabled = true
  /** 最近一次 setIconSize 的目標邊長（換圖後重算縮放用）。 */
  private iconSize = 0

  constructor(texture: Texture, onTap?: () => void) {
    super()
    this.icon = new Sprite(texture)
    this.icon.anchor.set(0.5)
    this.addChild(this.icon)

    this.eventMode = 'static'
    this.cursor = 'pointer'

    if (onTap !== undefined) {
      this.on('pointertap', () => {
        if (this.enabled) onTap()
      })
    }
    this.on('pointerover', () => {
      if (this.enabled) this.icon.alpha = 0.7
    })
    this.on('pointerout', () => {
      this.icon.alpha = 1
      this.icon.scale.set(this.baseScale)
    })
    this.on('pointerdown', () => {
      if (this.enabled) this.icon.scale.set(this.baseScale * 0.88)
    })
    this.on('pointerup', () => this.icon.scale.set(this.baseScale))
    this.on('pointerupoutside', () => this.icon.scale.set(this.baseScale))
  }

  /** 設定圖示的目標邊長（等比縮放至最長邊 = size），並同步方形點擊熱區。（不用 setSize 命名以免覆寫 Container.setSize） */
  setIconSize(size: number): void {
    this.iconSize = size
    const texture = this.icon.texture
    this.baseScale = size / Math.max(texture.width, texture.height)
    this.icon.scale.set(this.baseScale)
    this.hitArea = new Rectangle(-size / 2, -size / 2, size, size)
  }

  /** 換圖（Turbo／自動的開關態；沿用目前的目標邊長重算縮放）。 */
  setTexture(texture: Texture): void {
    if (this.icon.texture === texture) return
    this.icon.texture = texture
    if (this.iconSize > 0) this.setIconSize(this.iconSize)
  }

  setEnabled(enabled: boolean): void {
    this.enabled = enabled
    this.cursor = enabled ? 'pointer' : 'default'
    this.icon.alpha = enabled ? 1 : 0.35
  }
}
